export var NodeStateUpdateType;
(function (NodeStateUpdateType) {
    NodeStateUpdateType["NodeMove"] = "node-move";
    NodeStateUpdateType["NodeArrange"] = "node-arrange";
    NodeStateUpdateType["NodeHeightChange"] = "node-height-change";
    NodeStateUpdateType["NodeDelete"] = "node-delete";
    NodeStateUpdateType["NodeUpdate"] = "node-update";
    NodeStateUpdateType["NodeConnect"] = "node-connect";
})(NodeStateUpdateType || (NodeStateUpdateType = {}));
